// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","664":"reactPlayerPreview","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"46ece9e9f55bffe7c0c6","664":"8f006c518a86775fc9c7","731":"8bb9074d7fb655badf11","843":"26deb50f000c650b8a2f","883":"37808ec79a67b7961eff"}[chunkId] + ".js";
};